<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'GIS_LAYERS', url: '/admin/layer' },
    { label: 'UPDATE_LAYER' }
  ]"
></breadcrumbs>

<page-header title="UPDATE_LAYER"></page-header>
<content-loading *ngIf="tableColumns === undefined"></content-loading>
<ng-container *ngIf="tableColumns !== undefined">
  <card>
    <form autocomplete="off" class="form" (submit)="onSubmit($event)">
      <div class="field is-narrow">
        <label class="label" translationEditableDirective="NAME">{{
          'NAME' | translate
        }}</label>
        <div class="control">
          <input
            class="input is-small"
            name="name"
            type="text"
            (input)="handleFieldChange($event)"
            [value]="getField(['name'])"
            [ngClass]="{ 'is-danger': hasError('name') }"
          />
        </div>
        <p class="help is-danger" *ngIf="hasError('name')">
          {{ getError('name') }}
        </p>
      </div>

      <div class="field is-narrow">
        <label class="label" translationEditableDirective="COLOR">{{
          'COLOR' | translate
        }}</label>
        <color-picker
          (change)="handleFieldChange($event, 'color')"
          name="color"
          [value]="getField(['color'])"
          class="is-small"
        ></color-picker>
        <p class="help is-danger" *ngIf="hasError('color')">
          {{ getError('color') }}
        </p>
      </div>

      <div class="field is-narrow">
        <label class="label" translationEditableDirective="CALCULATION">{{
          'CALCULATION' | translate
        }}</label>
        <div class="control">
          <div class="switch">
            <label>
              <input
                [disabled]="false"
                [checked]="getField(['calculation'])"
                (change)="toggle('calculation', $event)"
                class="switch-input"
                name="calculation"
                type="checkbox"
              />
              <div><div></div></div>
            </label>
          </div>
        </div>
        <p class="help is-danger" *ngIf="hasError('calculation')">
          {{ getError('calculation') }}
        </p>
      </div>

      <div class="field is-narrow">
        <label class="label" translationEditableDirective="DELIVERY">{{
          'DELIVERY' | translate
        }}</label>
        <div class="control">
          <div class="switch">
            <label>
              <input
                [disabled]="false"
                [checked]="getField(['delivery'])"
                (change)="toggle('delivery', $event)"
                class="switch-input"
                name="delivery"
                type="checkbox"
              />
              <div><div></div></div>
            </label>
          </div>
        </div>
        <p class="help is-danger" *ngIf="hasError('delivery')">
          {{ getError('delivery') }}
        </p>
      </div>

      <div class="field is-narrow">
        <label class="label" translationEditableDirective="ACTIVE">{{
          'ACTIVE' | translate
        }}</label>
        <div class="control">
          <div class="switch">
            <label>
              <input
                [disabled]="false"
                [checked]="getField(['active'])"
                (change)="toggle('active', $event)"
                class="switch-input"
                name="active"
                type="checkbox"
              />
              <div><div></div></div>
            </label>
          </div>
        </div>
        <p class="help is-danger" *ngIf="hasError('active')">
          {{ getError('active') }}
        </p>
      </div>

      <hr />

      <div class="is-flex is-align-items-end is-justify-content-space-between">
        <div>
          <label class="label" translationEditableDirective="FILE">{{
            'FILE' | translate
          }}</label>
          <div class="field has-addons">
            <div class="control">
              <input
                class="input is-small"
                accept=".zip"
                name="file"
                type="file"
                (input)="handleFieldChange($event)"
                [ngClass]="{ 'is-danger': hasError('file') }"
              />
            </div>
            <div class="control">
              <button
                [disabled]="!getField(['file']) || uploading"
                type="button"
                (click)="upload()"
                class="button is-info"
              >
                {{ 'UPLOAD' | translate }}
              </button>
            </div>
          </div>
        </div>

        <button
          [disabled]="isLoading || tableColumns.length == 0"
          type="button"
          class="button is-success ml-3"
          translationEditableDirective="PREVIEW"
          (click)="previewVisible = true"
        >
          {{ 'PREVIEW' | translate }}
        </button>
      </div>

      <div
        *ngIf="tableColumns.length"
        class="mt-6 is-flex is-justify-content-space-between"
      >
        <div class="field">
          <label class="label" translationEditableDirective="ID_ATTR">{{
            'ID_ATTR' | translate
          }}</label>
          <div class="control">
            <div class="select">
              <select
                [ngClass]="{ 'is-danger': hasError('idAttr') }"
                name="idAttr"
                (input)="handleFieldChange($event)"
              >
                <option></option>
                <option
                  [selected]="getField(['idAttr']) === column"
                  *ngFor="let column of tableColumnNames"
                >
                  {{ column }}
                </option>
              </select>
            </div>
          </div>
          <p class="help is-danger" *ngIf="hasError('idAttr')">
            {{ getError('idAttr') }}
          </p>
        </div>

        <div class="is-flex">
          <div class="field mr-4">
            <label class="label" translationEditableDirective="FILL_LABELS">{{
              'FILL_LABELS' | translate
            }}</label>
            <div class="control">
              <div class="select">
                <select (change)="fillFields($event, 'label')">
                  <option></option>
                  <option *ngFor="let column of tableColumnNames">
                    {{ column }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="field">
            <label class="label" translationEditableDirective="FILL_VALUES">{{
              'FILL_VALUES' | translate
            }}</label>
            <div class="control">
              <div class="select">
                <select
                  [disabled]="!getField(['calculation'])"
                  (change)="fillFields($event, 'value')"
                >
                  <option></option>
                  <option *ngFor="let column of tableColumnNames">
                    {{ column }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="mt-4"
        style="max-height: 400px; overflow-y: auto"
        *ngIf="tableColumns.length"
      >
        <table class="table is-narrow mb-0">
          <thead>
            <tr>
              <th *ngFor="let column of tableColumns; let i = index">
                <span *ngIf="column !== 'Value' && column !== 'Label'">{{
                  column
                }}</span>
                <span
                  translationEditableDirective="VALUE"
                  *ngIf="column === 'Value'"
                  >{{ 'VALUE' | translate }}</span
                >
                <span
                  translationEditableDirective="LABEL"
                  *ngIf="column === 'Label'"
                  >{{ 'LABEL' | translate }}</span
                >
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of tableRows; let i = index">
              <td *ngFor="let column of tableColumns" style="width: 100px">
                <span *ngIf="column !== 'Label' && column !== 'Value'">
                  {{ row.attributes[column] }}
                </span>

                <input
                  class="input is-small"
                  type="text"
                  name="label"
                  *ngIf="column === 'Label'"
                  [value]="row['label']"
                  (input)="handleRowFieldChange($event, i)"
                />
                <number-input
                  [disabled]="!getField(['calculation'])"
                  name="value"
                  *ngIf="column === 'Value'"
                  [value]="row['value']"
                  (input)="handleRowFieldChange($event, i)"
                  [inputClass]="{
                    'input is-small': true,
                    'is-danger': hasError('features.' + i + '.value')
                  }"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </form>
  </card>

  <div class="field is-grouped pt-3 px-3 mb-3">
    <div class="control">
      <button
        [disabled]="isLoading"
        type="submit"
        class="button is-success"
        translationEditableDirective="SUBMIT"
        (click)="onSubmit($event)"
      >
        {{ 'SUBMIT' | translate }}
      </button>
    </div>
    <div class="control">
      <a
        [routerLink]="['/admin/layer']"
        class="button is-link is-light"
        translationEditableDirective="CANCEL"
        >{{ 'CANCEL' | translate }}</a
      >
    </div>
  </div>
</ng-container>

<layer-map
  (onClose)="previewVisible = false"
  [id]="layerId"
  [color]="getField(['color'])"
  *ngIf="previewVisible"
></layer-map>
